import React, { Component } from "react";
import Moment from "moment";
import Swal from "sweetalert2";
import { Printer } from "react-bootstrap-icons";
import ReactToPrint from "react-to-print";
import AppContext from "../../appContext";
import { PROMO_SEARCH_TERMS, PROMOCAO_TYPES, VOUCHER_PREFIX } from "../../web-ordering/pdf-order/constant/promo-types";
import { resolverParDoPedido } from "../../Functions/voucher/par-do-pedido";
import ServicesUtils from "../../shared/utils/ServicesUtils";
import "./tracking-order-view.css";

class TrackingOrderView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      order: null,
      tipoArmacaoDescricao: "",
      empresa_faturamento: "",
      promoName: "",
      parInfo: "",
    };
    this.printRef = React.createRef();
    TrackingOrderView.contextType = AppContext;
  }

  componentDidMount() {
    this.fetchOrderData();
  }

  async fetchOrderData() {
    const { laboratorio_cnpj, otica_cnpj, pedido_id } = this.props;

    const table = document.getElementById("main-tabela");
    if (table) table.classList.add("main-tabela-opacity");
    this.context.showLoading("");

    const header = {
      client_id: localStorage.getItem("clientid"),
      access_token: sessionStorage.getItem("token"),
      laboratorio: laboratorio_cnpj,
      otica: otica_cnpj,
    };

    const requestOptions = { method: "GET", headers: header };

    try {
      const response = await fetch(
        process.env.REACT_APP_ESSILOR_API + "gestao-pedidos-laboratorio/v1/pedidos/" + pedido_id,
        requestOptions
      );

      if (response.status !== 200) {
        this.context.hideLoading();
        if (table) table.classList.remove("main-tabela-opacity");
        Swal.fire({
          html: "Erro ao recuperar as informacoes do pedido.",
          icon: "warning",
          title: "Aviso",
          confirmButtonColor: "#00518b",
        });
        this.setState({ loading: false });
        return;
      }

      const json = await response.json();

      if (json?.hasOwnProperty("codigo")) {
        this.context.hideLoading();
        if (table) table.classList.remove("main-tabela-opacity");
        Swal.fire({
          html: json.mensagem,
          icon: "error",
          title: "Aviso",
          confirmButtonColor: "#00518b",
        });
        this.setState({ loading: false });
        return;
      }

      let tipoArmacaoDescricao = "";
      if (json?.armacao?.tipo) {
        const codigoLinha = json?.receita?.olhoDireito?.codigoLinhaProduto || json?.receita?.olhoEsquerdo?.codigoLinhaProduto;
        if (codigoLinha) {
          tipoArmacaoDescricao = await this.fetchTipoArmacao(codigoLinha, json.armacao.tipo);
        }
        if (!tipoArmacaoDescricao) {
          tipoArmacaoDescricao = this.fallbackTipoArmacao(json.armacao.tipo);
        }
      }

      let empresaFaturamento = "";
      try {
        const accResp = await fetch(process.env.REACT_APP_LABS_API + "get_account_data.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ cnpj: otica_cnpj || this.context.userSession.conta }),
        });
        const accJson = await accResp.json();
        empresaFaturamento = accJson.nome || "";
      } catch (_) { }

      const { promoName, parInfo } = await this.resolvePromoInfo(json);

      let formatoAroImg = "";
      if (json?.armacao?.modelo) {
        formatoAroImg = await this.fetchFormatoAro(json.armacao.modelo);
      }

      this.setState({
        order: json,
        loading: false,
        tipoArmacaoDescricao,
        empresa_faturamento: empresaFaturamento,
        promoName,
        parInfo,
        formatoAroImg,
      });

      this.context.hideLoading();
      if (table) table.classList.remove("main-tabela-opacity");
    } catch (err) {
      this.context.hideLoading();
      if (table) table.classList.remove("main-tabela-opacity");
      this.setState({ loading: false });
    }
  }

  async fetchTipoArmacao(codigoLinha, tipoArmacao) {
    try {
      const { laboratorio_cnpj, otica_cnpj } = this.props;
      const headers = {
        access_token: sessionStorage.getItem("token"),
        laboratorio: laboratorio_cnpj,
        otica: otica_cnpj,
      };
      const resp = await fetch(
        process.env.REACT_APP_ESSILOR_API + "gestao-produtos-laboratorio/v1/produtos/" + codigoLinha + "/parametros",
        { method: "GET", headers }
      );
      if (resp.status === 200) {
        const json = await resp.json();
        const dominio = json?.armacao?.tipo?.dominio;
        if (dominio?.length) {
          const found = dominio.find(item => String(item.codigo) === String(tipoArmacao));
          if (found) return found.descricao;
        }
      }
      return "";
    } catch (_) {
      return "";
    }
  }

  fallbackTipoArmacao(tipo) {
    const map = { 1: "METAL", 2: "ACETATO", 3: "PARAFUSO", 4: "NYLON", 5: "SEG METAL", 6: "SEG ACETATO", 7: "FIO DE ACO" };
    return map[parseInt(tipo)] || "";
  }

  async fetchFormatoAro(modeloCodigo) {
    try {
      const { laboratorio_cnpj, otica_cnpj } = this.props;
      const headers = {
        access_token: sessionStorage.getItem("token"),
        laboratorio: laboratorio_cnpj,
      };
      if (otica_cnpj) headers.otica = otica_cnpj;

      const resp = await fetch(
        process.env.REACT_APP_ESSILOR_API + "gestao-produtos-laboratorio/v1/modelos-lentes",
        { method: "GET", headers }
      );
      if (resp.status === 200) {
        const modelos = await resp.json();
        if (Array.isArray(modelos)) {
          const found = modelos.find(m => String(m.codigo) === String(modeloCodigo));
          if (found?.formato) return found.formato;
        }
      }
      return "";
    } catch (_) {
      return "";
    }
  }

  async resolvePromoInfo(json) {
    let promoName = "";

    if (json?.promocao?.campanha?.nome) {
      promoName = json.promocao.campanha.nome;
      if (promoName.includes(PROMO_SEARCH_TERMS.DOSE_DUPLA_KODAK) ||
        (json.promocao.voucher?.startsWith(VOUCHER_PREFIX.KODAK_PREFIX) && promoName.includes("KODAK"))) {
        promoName = PROMOCAO_TYPES.DOSE_DUPLA_KODAK;
      } else if (promoName.includes(PROMO_SEARCH_TERMS.VARILUX) && promoName.includes(PROMO_SEARCH_TERMS.DOBRO)) {
        promoName = PROMOCAO_TYPES.VARILUX_DOBRO;
      } else if (promoName.includes(PROMO_SEARCH_TERMS.CRIZAL) && promoName.includes(PROMO_SEARCH_TERMS.DOBRO)) {
        promoName = PROMOCAO_TYPES.CRIZAL_DOBRO;
      }
    }

    const { parInfo } = await resolverParDoPedido(json);

    const isEmDobro = promoName && (
      (promoName.toUpperCase().includes("VARILUX") && promoName.toUpperCase().includes("DOBRO")) ||
      (promoName.toUpperCase().includes("CRIZAL") && promoName.toUpperCase().includes("DOBRO")) ||
      promoName.toUpperCase().includes("DOSE DUPLA KODAK")
    );
    if (parInfo && promoName && isEmDobro) {
      promoName = `${promoName} ${parInfo}`;
    }

    return { promoName, parInfo };
  }

  val(v) {
    return v !== undefined && v !== null && v !== "" && v !== "null" && v !== "undefined" ? v : "-";
  }

  hasData(...values) {
    return values.some(v => v !== undefined && v !== null && v !== "" && v !== "null" && v !== "undefined");
  }

  renderSemDados() {
    return (
      <div className="tov-no-data">
        <span>Sem dados</span>
      </div>
    );
  }

  renderEye(label, olho, parametros) {
    if (!olho) {
      return (
        <div className="tov-eye">
          <div className="tov-eye-title">{label}</div>
          <div className="tov-eye-body tov-eye-no-data">
            <span>Sem dados</span>
          </div>
        </div>
      );
    }

    const produto = olho.produto || "";
    const esf = this.val(olho.grauEsferico);
    const cil = olho.grauCilindro === "0.00" ? "" : this.val(olho.grauCilindro);
    const eixo = this.val(olho.eixo);
    const adicao = this.val(olho.adicao);
    const dnp = this.val(olho.dnp);
    const alt = this.val(olho.altura);

    // PERTO = esferico + adicao
    let pertoEsf = "-";
    let pertoCil = cil;
    let pertoEixo = eixo;
    if (olho.grauEsferico && olho.adicao) {
      const esfNum = parseFloat(String(olho.grauEsferico).replace(",", "."));
      const addNum = parseFloat(String(olho.adicao).replace(",", "."));
      if (!isNaN(esfNum) && !isNaN(addNum)) {
        pertoEsf = (esfNum + addNum).toFixed(2).replace(",", ".");
      }
    }

    const dnpPerto = this.val(parametros?.dnpPerto);
    const cro = this.val(parametros?.cro);
    const distVertice = this.val(parametros?.distanciaVertice);
    const bOpticlick = this.val(parametros?.base || olho.base);
    const ct = this.val(olho.ct);
    const et = this.val(olho.et);

    const prismaH = this.val(olho.valorPrismaHorizontal);
    const prismaHEixo = this.val(olho.eixoPrismaHorizontal);
    const prismaV = this.val(olho.valorPrismaVertical);
    const prismaVEixo = this.val(olho.eixoPrismaVertical);

    const hasPrisma = [olho.valorPrismaHorizontal, olho.eixoPrismaHorizontal, olho.valorPrismaVertical, olho.eixoPrismaVertical]
      .some(v => v !== undefined && v !== null && v !== "" && v !== "0" && v !== 0);

    return (
      <div className="tov-eye">
        <div className="tov-eye-title">{label}</div>
        <div className="tov-eye-body">
          <div className="tov-eye-lente text-left">
            <strong>Lente: </strong>{produto || "-"}
          </div>

          <table className="tov-table">
            <thead>
              <tr>
                <th></th>
                <th>Esf.</th>
                <th>Cil.</th>
                <th>Eixo</th>
                <th>Adição</th>
                <th>DNP</th>
                <th>Alt.</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tov-label-cell" width="100px"><span className="tov-badge">LONGE</span></td>
                <td>{esf}</td>
                <td>{cil}</td>
                <td>{eixo}</td>
                <td>{adicao}</td>
                <td>{dnp}</td>
                <td>{alt}</td>
              </tr>
              <tr>
                <td className="tov-label-cell" width="100px"><span className="tov-badge">PERTO</span></td>
                <td>{pertoEsf}</td>
                <td>{pertoCil}</td>
                <td>{pertoEixo}</td>
                <td colSpan="3"></td>
              </tr>
            </tbody>
          </table>

          <table className="tov-table">
            <thead>
              <tr>
                <th>DNP Perto</th>
                <th>CRO</th>
                <th>Dist. Vertice</th>
                <th>B. Opticlick</th>
                <th>CT</th>
                <th>ET</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{dnpPerto}</td>
                <td>{cro}</td>
                <td>{distVertice}</td>
                <td>{bOpticlick}</td>
                <td>{ct}</td>
                <td>{et}</td>
              </tr>
            </tbody>
          </table>

          {hasPrisma && (
            <table className="tov-table">
              <thead>
                <tr>
                  <th>Prisma H.</th>
                  <th>Eixo</th>
                  <th>Prisma V.</th>
                  <th>Eixo</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{prismaH}</td>
                  <td>{prismaHEixo}</td>
                  <td>{prismaV}</td>
                  <td>{prismaVEixo}</td>
                </tr>
              </tbody>
            </table>
          )}
        </div>
      </div>
    );
  }

  renderMedidasPersonalizadas(json) {
    const params = json?.parametros;
    const paciente = json?.paciente;
    if (!params) return null;

    const olho = params.olhoDireito || params.olhoEsquerdo;
    if (!olho && !paciente?.iniciaisPaciente && !params.olhoDominante) return null;

    const items = [
      { label: "Iniciais Cliente", value: paciente?.iniciaisPaciente },
      { label: "Coeficiente Cabeça-Olhos", value: olho?.coeficienteHE },
      { label: "Distância Leitura", value: olho?.distanciaLeitura },
      { label: "Estabilidade", value: olho?.coeficienteST },
      { label: "CVP", value: olho?.cvp },
      { label: "Distância Progressão", value: olho?.distanciaProgressao },
      { label: "Ângulo Pantoscópico", value: olho?.anguloPantoscopico },
      { label: "Curvatura Armação", value: olho?.anguloCurvatura },
      { label: "Olho Dominante", value: params.olhoDominante },
    ]/*.filter(i => i.value !== undefined && i.value !== null && i.value !== "")*/;

    if (items.length === 0) return null;

    const allEmpty = !items.some(i => this.hasData(i.value));

    return (
      <div className="tov-section">
        <div className="tov-section-title">Medidas Personalizadas</div>
        <div className="tov-section-body">
          {allEmpty ? this.renderSemDados() : (
            <table className="tov-armacao-table">
              <thead>
                <tr>
                  {items.map((item, idx) => (
                    <th key={idx}>{item.label}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {items.map((item, idx) => (
                    <td key={idx}>{this.val(item.value)}</td>
                  ))}
                </tr>
              </tbody>
            </table>
          )}
        </div>
      </div>
    );
  }

  renderServicos(json) {
    const ar = ServicesUtils.getAntirreflexoPreferido(json?.servicos);
    const coloracao = json?.servicos?.find(s => s.tipo === "COLORACAO");
    const montagem = json?.servicos?.find(s => s.tipo === "MONTAGEM");
    const cor = json?.corColoracao?.descricao || "";
    const hasServicos = ar || coloracao || montagem || cor;

    return (
      <div className="tov-section">
        <div className="tov-section-title">Serviços</div>
        <div className="tov-section-body">
          {hasServicos ? (
            <div className="tov-servicos-row">
              {ar && <span><strong>AR</strong> {ar.descricao}</span>}
              {coloracao && <span className="text-left"><strong>COLORAÇÃO</strong> {coloracao.descricao || "-"}</span>}
              {cor && <span className="text-left"><strong>COR</strong> {cor}</span>}
              {montagem && <span><strong>CORTE/MONTAGEM</strong> {montagem.descricao}</span>}
            </div>
          ) : this.renderSemDados()}
        </div>
      </div>
    );
  }

  renderArmacao(json) {
    const arm = json?.armacao;
    if (!arm) return null;

    const cor = arm.descricaoCor || arm.cor?.descricao || (typeof arm.cor === "string" ? arm.cor : "");
    const { formatoAroImg, tipoArmacaoDescricao } = this.state;

    const armacaoVazia = !this.hasData(arm.vertical, arm.horizontal, arm.diametroMaior, arm.ponte, arm.referencia, cor, arm.marca, tipoArmacaoDescricao) && !formatoAroImg;

    return (
      <div className="tov-section">
        <div className="tov-section-title">Armação</div>
        <div className="tov-section-body">
          {armacaoVazia ? this.renderSemDados() : (
            <table className="tov-armacao-table">
              <thead>
                <tr>
                  <th>Vertical</th>
                  <th>Horizontal</th>
                  <th>Diagonal Maior</th>
                  <th>Ponte</th>
                  <th>Referência</th>
                  <th>Cor</th>
                  <th>Marca</th>
                  <th>Tipo</th>
                  <th>Formato do Aro</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{this.val(arm.vertical)}</td>
                  <td>{this.val(arm.horizontal)}</td>
                  <td>{this.val(arm.diametroMaior)}</td>
                  <td>{this.val(arm.ponte)}</td>
                  <td>{this.val(arm.referencia)}</td>
                  <td>{this.val(cor)}</td>
                  <td>{this.val(arm.marca)}</td>
                  <td>{this.val(tipoArmacaoDescricao)}</td>
                  <td className="tov-formato-aro-cell">
                    {formatoAroImg ? (
                      <img
                        src={`data:image/png;base64,${formatoAroImg}`}
                        alt="Formato do Aro"
                        className="tov-formato-aro-img"
                      />
                    ) : "-"}
                  </td>
                </tr>
              </tbody>
            </table>
          )}
        </div>
      </div>
    );
  }

  renderCampanha(json) {
    const promo = json?.promocao;
    const campanhaVazia = !this.hasData(promo?.voucher, this.state.promoName, promo?.campanha?.tipo);

    return (
      <div className="tov-section">
        <div className="tov-section-title">Campanha Essilor Promo</div>
        <div className="tov-section-body">
          {campanhaVazia ? this.renderSemDados() : (
            <div className="tov-info-grid">
              <div className="tov-info-item">
                <span>Cupom Promocional:</span>
                <span>{promo?.voucher ?? "-"}</span>
              </div>
              <div className="tov-info-item">
                <span>Nome da Promoção:</span>
                <span>{this.state.promoName || "-"}</span>
              </div>
              <div className="tov-info-item">
                <span>Tipo da Promoção:</span>
                <span>{promo?.campanha?.tipo ?? "-"}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  renderPromocaoLaboratorio(json) {
    const promocaoLaboratorio = json?.promocaoLaboratorio;
    if (!promocaoLaboratorio || !this.hasData(promocaoLaboratorio.descricao, promocaoLaboratorio.idPedido)) return null;

    return (
      <div className="tov-section">
        <div className="tov-section-title">Promoção {this.props.laboratorio_nome}</div>
        <div className="tov-section-body">
          <div className="tov-info-grid">
            <div className="tov-info-item">
              <span>Nome Promoção:</span>
              <span>{this.val(promocaoLaboratorio.descricao)}</span>
            </div>
            <div className="tov-info-item">
              <span>Pedido de origem da promoção:</span>
              <span>{this.val(promocaoLaboratorio.idPedido)}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderObservacoes(json) {
    if (!json?.observacao) return null;

    return (
      <div className="tov-section">
        <div className="tov-section-title">Observações</div>
        <div className="tov-section-body">
          <p>{json.observacao}</p>
        </div>
      </div>
    );
  }

  renderOutrasInformacoes(json) {
    const items = [
      { label: "Empresa de Faturamento", value: this.state.empresa_faturamento },
      { label: "Nome do Cliente", value: json?.paciente?.nome },
      { label: "CPF do Cliente", value: json?.paciente?.cpf },
      { label: "Nome do Médico", value: json?.medico?.nome },
      { label: "CRM do Médico", value: json?.medico?.crm },
      { label: "Código do Participante (Vendedor)", value: json?.programaLaboratorio?.codigoParticipante },
    ].filter(i => i.value !== undefined && i.value !== null && i.value !== "");

    if (items.length === 0) return null;

    return (
      <div className="tov-section">
        <div className="tov-section-title">Outras Informações</div>
        <div className="tov-section-body">
          <div className="tov-info-grid">
            {items.map((item, idx) => (
              <div className="tov-info-item" key={idx}>
                <span>{item.label}:</span>
                <span>{item.value}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  render() {
    if (this.state.loading) {
      return <div className="tov-loading">Carregando pedido...</div>;
    }

    if (!this.state.order) {
      return <div className="tov-loading">Não foi possível carregar o pedido.</div>;
    }

    return (
      <div>
        <div className="tov" ref={this.printRef}>
          <div className="tov-header">
            <div className="tov-header-logo">
              <img src="image/modulos/Conecta_Pedidos.png" alt="Conecta Pedidos" className="module_logo-img" />
            </div>
            <div className="tov-header-left text-left">
              <span><strong>Emissão:</strong> {this.props.data_entrada ? Moment(this.props.data_entrada).format("DD/MMM/YYYY") : "-"}</span>
              <span><strong>Previsão:</strong> {this.props.data_prevista || "-"}</span>
              <span><strong>Status:</strong> {this.props.status_atual || "-"}</span>
            </div>
            <div className="tov-header-right">
              <span><strong>Pedido no Laboratório:</strong> {this.props.pedido_id}</span>
              <span><strong>Pedido na Ótica:</strong> {this.props.pedido_otica || "-"}</span>
              <ReactToPrint
                trigger={() => (
                  <button className="tov-print-btn">
                    <Printer size={16} />
                    IMPRIMIR
                  </button>
                )}
                content={() => this.printRef.current}
                documentTitle={`Essilor Conecta - Detalhes Pedido ${this.props.pedido_id || "Essilor Conecta - Detalhes Pedido"}`}
              />
            </div>
          </div>

          <div className="tov-eyes">
            {this.renderEye("Olho Direito", this.state.order.receita?.olhoDireito, this.state.order.parametros?.olhoDireito)}
            {this.renderEye("Olho Esquerdo", this.state.order.receita?.olhoEsquerdo, this.state.order.parametros?.olhoEsquerdo)}
          </div>

          {this.renderMedidasPersonalizadas(this.state.order)}
          {this.renderServicos(this.state.order)}
          {this.renderArmacao(this.state.order)}
          {this.renderPromocaoLaboratorio(this.state.order)}
          {this.renderCampanha(this.state.order)}
          {this.renderObservacoes(this.state.order)}
          {this.renderOutrasInformacoes(this.state.order)}
        </div>

      </div>
    );
  }
}

export default TrackingOrderView;
